'use client';

import { useId } from 'react';

/**
 * RepetixLogo Component
 *
 * The Repetix brand logo - circular arrow with checkmark
 * representing recurring subscriptions being tracked/protected.
 *
 * Matches the favicon design exactly.
 */

interface RepetixLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function RepetixLogo({ size = 'md', className = '' }: RepetixLogoProps) {
  const gradientId = useId();

  const sizeClasses = {
    sm: 'w-7 h-7',
    md: 'w-8 h-8',
    lg: 'w-9 h-9',
  };

  const viewBox = '0 0 32 32';

  return (
    <svg
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${sizeClasses[size]} ${className}`}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8B5CF6"/>
          <stop offset="100%" stopColor="#EC4899"/>
        </linearGradient>
      </defs>

      {/* Background rounded square with brand gradient */}
      <rect width="32" height="32" rx="8" fill={`url(#${gradientId})`}/>

      {/* Circular arrow representing recurring/repeat */}
      <path
        d="M16 7C11.0294 7 7 11.0294 7 16C7 20.9706 11.0294 25 16 25C20.9706 25 25 20.9706 25 16"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />

      {/* Arrow head on the circle */}
      <path
        d="M25 12V16H21"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />

      {/* Checkmark inside */}
      <path
        d="M12 16L14.5 18.5L20 13"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
